export enum ModuleCelerusEnum {
    master = 1,
    dashboard = 2,
    totem = 3,
    medic = 4,
    generic_call = 6,
    frontdesk = 7,
    sadt = 8,
    classification = 9,
    audit = 10,
    integration = 11,
    observation = 12,
    patient_history = 13,
    form = 14,
    billing = 15,
    remote_monitoring = 16,
    pharmacy = 17,
    business_intelligence = 18,
    self_triage = 19,
    telemedicine = 20,
    multi_professional = 21,
    flow_management = 22,
    ubs_monitoring = 23,
}